export function IncognitoIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M17 9.87a21.772 21.772 0 001.705-.477c.525-.17 1.101.09 1.295.607a.968.968 0 01-.592 1.268 23.784 23.784 0 01-14.816 0A.968.968 0 014 10c.194-.517.77-.777 1.295-.607a21.78 21.78 0 001.706.476C7.049 6.89 9.018 4 12 4c2.982 0 4.951 2.89 5 5.87zm-6.082 7.83A3.001 3.001 0 015 17a3 3 0 015.697-1.315c.856-.21 1.75-.21 2.606 0a3 3 0 11-.22 2.016 3.473 3.473 0 00-2.165 0zM8 18a1 1 0 100-2 1 1 0 000 2zm8 0a1 1 0 100-2 1 1 0 000 2z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
